import { t } from "@lingui/macro";
import { db } from "@repo/ui";
import { doc, onSnapshot } from "firebase/firestore";
import { X } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "./ui/button";

const APP_VERSION =
	import.meta.env.VITE_APP_VERSION || __COMMIT_HASH__ || "dev";
const COMPONENT_NAME = import.meta.env.VITE_COMPONENT_NAME || "app-frontend";

export function RefreshVersionBanner() {
	const [latestVersion, setLatestVersion] = useState<string | null>(null);
	const [dismissedVersion, setDismissedVersion] = useState<string | null>(null);

	useEffect(() => {
		return onSnapshot(doc(db, "settings", "system"), (snapshot) => {
			const latestVersions = snapshot.data()?.latestVersions as
				| Record<string, string>
				| undefined;
			const latestVersion = latestVersions?.[COMPONENT_NAME];
			setLatestVersion(
				latestVersion && latestVersion !== APP_VERSION ? latestVersion : null,
			);
		});
	}, []);

	const isStale = Boolean(latestVersion && latestVersion !== dismissedVersion);

	if (!isStale) return null;

	return (
		<div className="fixed top-4 left-1/2 z-50 flex w-[calc(100%-2rem)] max-w-xl -translate-x-1/2 items-center justify-between gap-4 rounded-lg border border-warn/30 bg-card px-4 py-3 text-sm shadow-md">
			<span className="min-w-0 font-semibold text-foreground">
				{t({
					id: "refreshVersionBanner.message",
					message: "A new version is available. Refresh to update.",
				})}
			</span>
			<div className="flex shrink-0 items-center gap-2">
				<Button
					type="button"
					size="sm"
					className="bg-warn-tint text-foreground hover:bg-warn-tint/80"
					onClick={() => window.location.reload()}
				>
					{t({ id: "refreshVersionBanner.refreshButton", message: "Refresh" })}
				</Button>
				<Button
					type="button"
					variant="ghost"
					size="icon"
					className="text-muted-foreground hover:bg-secondary hover:text-foreground"
					aria-label={t({
						id: "refreshVersionBanner.dismissButton",
						message: "Dismiss update notice",
					})}
					onClick={() => setDismissedVersion(latestVersion)}
				>
					<X className="h-4 w-4" />
				</Button>
			</div>
		</div>
	);
}
